import React from "react";
import { connect } from "react-redux";
import {
    Container,
     Grid,
    Typography, AppBar, Toolbar, CircularProgress, IconButton, Tooltip
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { ArrowBack, ChevronLeft, ChevronRight, Delete } from "@mui/icons-material"
import { withTranslation } from 'react-i18next';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import clsx from "clsx";
import StandardOptionsGrid from "./StandardOptionsGrid";
import Dropzone from "../../components/Dropzone";
import { validateFile, authHeader } from "../../_helpers";
import ConfirmBox from "../../components/ConfirmBox";
import { flushSync } from "react-dom";
const { webApiUrl } = window.appConfig;

const styles = theme => ({
    appBar:{
        boxShadow:'none',
        zIndex: 999,
    },
    grow: {
        flexGrow: 1
    },
    bold: {
        fontWeight: "bold"
    },
    mainContainer: {
        height: '100%',
        width: '100%',
        overflow: 'auto',
        padding: 0
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(0)
        }
    },
    innerContainer: {
        padding: theme.spacing(2)
    },
    bigAvatar: {
        margin: 'auto',
        width: 120,
        height: 120
    },
    button: {
        '&:hover': {
            color: theme.palette.primary.contrastText
        }
    },
    dropzoneContainer: {
        width: '33.33%',
        float: 'left',
        padding: theme.spacing(1),
        marginBottom: -10,
        [theme.breakpoints.down('lg')]: {
            width: '40%',
        },
        [theme.breakpoints.down('md')]: {
            width: '50%',
        }
    },
    imageBlock: {
        width: '16.66%',
        float: 'left',
        padding: theme.spacing(1),
        position: 'relative',
        '& > button': {
            position: 'absolute',
            top: 0,
            right: 0
        },
        [theme.breakpoints.down('lg')]: {
            width: '20%',
        },
        [theme.breakpoints.down('md')]: {
            width: '25%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '50%',
        }
    }
});


const SortableItem = SortableElement(({ image, classes, attachmentToDelete, handleDeleteFile, canEdit }) =>
    <div className={classes && classes.imageBlock}>
        <div style={
            {
                backgroundImage: 'url(' + webApiUrl + 'api/home/GetAttachment/' + encodeURI(image.id) + ')',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                padding: '50% 0',
                height: 0
            }}>
        </div>
        <IconButton
            color="secondary"
            aria-label="delete"
            disabled={attachmentToDelete === image.id || !canEdit}
            onClick={() => handleDeleteFile(image.id)}
            size="large">
            {
                attachmentToDelete === image.id ?
                    <CircularProgress color="inherit" size={24} />
                    :
                    <Delete />
            }
        </IconButton>
    </div>);

const SortableList = SortableContainer(({ images, classes, selectedOption, uploading, attachmentToDelete, handleUploadFiles, handleDeleteFile, canEdit }) => {
    return (
        <div>
            <div className={classes.dropzoneContainer}>
                <Dropzone onFilesAdded={handleUploadFiles} disabled={!selectedOption || uploading === true || !canEdit} uploading={uploading} accept="image/*" />
            </div>

            {images.map((image, index) => (
                <SortableItem disabled={!canEdit} canEdit={canEdit} key={`item-${image.id}`} index={index} image={image} classes={classes} attachmentToDelete={attachmentToDelete} handleDeleteFile={handleDeleteFile} />
            ))}
        </div>
    );
});

class Page extends React.Component {
    state = {
        loading:true,
        options: [],
        uploading: false,
        selectedOption: null,
        prevOption: null,
        nextOption: null,
        images: [],
        confirmModal:null
    };

    componentDidMount() {
        this.UpdateStandardOptions();
    }

    componentDidUpdate(prevProps, prevState) {
        if ((!prevProps.selected || !this.props.selected || prevProps.selected.projectId.toUpperCase() !== this.props.selected.projectId.toUpperCase()) || this.props.location.key !== prevProps.location.key) {
            this.UpdateStandardOptions();
        }
        if (this.state.selectedOption !== prevState.selectedOption) {
            this.UpdateImages();
        }
    }

    UpdateStandardOptions() {
        const { selected } = this.props;
        if (selected) {
            const url = webApiUrl + 'api/shopping/GetStandardOptionsPerProject/' + encodeURI(selected.projectId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            flushSync(() => {
                this.setState({
                    options: [],
                    uploading: false,
                    selectedOption: null,
                    images: []
                });
            })
           
            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                    flushSync(()=>{this.setState({ options: findResponse });})
                });
        }
    }

    UpdateImages() {
        const { selectedOption } = this.state;
        if (selectedOption) {
            const url = webApiUrl + 'api/shopping/GetStandardOptionImageList/' + encodeURI(selectedOption.optionStandardId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                    flushSync(()=>{this.setState({ images: findResponse });})
                });
        }
        else {
            flushSync(()=>{this.setState({ images: [] });})
        }
    }

    UpdateOrderOfImages(lstIds) {
        const { selectedOption } = this.state;
        const { t } = this.props;
        if (selectedOption) {
            const url = webApiUrl + 'api/shopping/SortStandardOptionAttachments';
            const requestOptions = {
                method: 'POST',
                headers: authHeader('application/json'),
                body: JSON.stringify(lstIds)
            };

            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                })
                .catch(e => {
                    alert(t('general.api.error'));
                });
        }
    }

    markOptionSelected = option => {
        const { options } = this.state;
        var index = options.findIndex(x => option && x.optionStandardId === option.optionStandardId);
        const prevOption = index > 0 ? options[index - 1] : null;
        const nextOption = index >= 0 && index != options.length - 1 ? options[index + 1] : null;
        console.debug(index)
        flushSync(()=>{this.setState({ selectedOption: option, prevOption, nextOption });})
    }

    arrayMove(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { images } = this.state;
        const oldOrderIds = images.map(x => x.id);
        const updatedOrder = this.arrayMove(images, oldIndex, newIndex);
        flushSync(()=>{
             this.setState({
            images: updatedOrder,
        });
        })

        var ids = updatedOrder.map(x => x.id)//.join();

        if (JSON.stringify(ids) !== JSON.stringify(oldOrderIds))
            this.UpdateOrderOfImages(ids);
    };

    handleUploadFiles = files => {
        let filesToUpload = [];
        for (let i = 0; i < files.length; i++) {
            if (validateFile({file:files[i], allowImage:true}) === true) {
                filesToUpload.push(files[i]);
            }
        }

        if (filesToUpload.length > 0) {
            flushSync(()=>{this.setState({ uploading: true })})
            const { selected, t, user } = this.props;
            const { selectedOption, images } = this.state;

            const formData = new FormData();

            for (let i = 0; i < filesToUpload.length; i++) {
                formData.append('files', filesToUpload[i])
            }

            fetch(webApiUrl + `api/shopping/UploadStandardOptionImages/` + selectedOption.optionStandardId, {
                method: 'POST',
                headers: authHeader(),
                body: formData
            })
                .then(Response => Response.json())
                .then(res => {
                    this.UpdateImages();
                    flushSync(()=>{this.setState({ uploading: false })})
                })
                .catch(e => {
                    flushSync(()=>{this.setState({ uploading: false })})
                    alert(t('general.api.error'));
                })
        }
    }

    handleDeleteFile = attachmentId => {
        const { t } = this.props;
        flushSync(()=>{this.setState({ attachmentToDelete: attachmentId });})
        fetch(webApiUrl + `api/shopping/DeleteStandardOptionAttachment/` + attachmentId, {
            method: 'DELETE',
            headers: authHeader()
        })
            .then(Response => Response.json())
            .then(res => {
                this.UpdateImages();
            })
            .catch(e => {
                flushSync(()=>{this.setState({ attachmentToDelete: null });})
                alert(t('general.api.error'));
            })
    }
    openDeleteConfirmation = (id) => {
        flushSync(()=>{this.setState({ confirmModal: { open: true, data: id, for: "delete-file" } })})
    }
    render() {
        const { t, classes, rights } = this.props;
        const { options, uploading, selectedOption, prevOption, nextOption, images, attachmentToDelete } = this.state;

        return (
            (<Container className={classes.mainContainer} maxWidth={false}>
                <Grid container>
                    <Grid container className={classes.container} size={{xs:12}}>
                        <AppBar position="sticky" color='inherit' className={classes.appBar}>
                            <Toolbar variant="dense">
                                {
                                    selectedOption ?
                                        <React.Fragment>
                                            <IconButton
                                                aria-label="GoBack"
                                                edge="start"
                                                color="inherit"
                                                onClick={() => this.markOptionSelected(null)}
                                                size="large">
                                                <ArrowBack />
                                            </IconButton>
                                            <Typography className={clsx(classes.grow, classes.bold)} noWrap>{selectedOption.optionNo + ' ' + selectedOption.description}</Typography>
                                            <Tooltip title={t('buyersGuide.standardOptions.previousOption')}>
                                                <IconButton
                                                    aria-label="Prev"
                                                    color="inherit"
                                                    disabled={!prevOption}
                                                    onClick={() => this.markOptionSelected(prevOption)}
                                                    size="large">
                                                    <ChevronLeft />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={t('buyersGuide.standardOptions.nextOption')}>
                                                <IconButton
                                                    aria-label="Prev"
                                                    edge="end"
                                                    color="inherit"
                                                    disabled={!nextOption}
                                                    onClick={() => this.markOptionSelected(nextOption)}
                                                    size="large">
                                                    <ChevronRight />
                                                </IconButton>
                                            </Tooltip>
                                        </React.Fragment>
                                        :
                                        <Typography className={clsx(classes.grow, classes.bold)}>{t('buyersGuide.standardOptions.standardOptionsConfiguration')}</Typography>
                                }
                            </Toolbar>
                        </AppBar>
                        {
                            selectedOption ?
                                <Grid className={classes.innerContainer} size={{xs:12}}>
                                    <SortableList canEdit={rights['page.standardOptions.write']} axis="xy" distance={10} images={images} classes={classes} selectedOption={selectedOption} uploading={uploading} attachmentToDelete={attachmentToDelete} handleUploadFiles={this.handleUploadFiles} handleDeleteFile={this.openDeleteConfirmation} onSortEnd={this.onSortEnd} />
                                </Grid>
                                :
                                <Grid size={{xs:12}}>
                                    <StandardOptionsGrid options={options} onSelect={this.markOptionSelected} />
                                </Grid>
                        }
                    </Grid>
                </Grid>
                <ConfirmBox open={this.state.confirmModal?.open && this.state.confirmModal?.for === "delete-file"} title={t("general.warning")} description={t("general.deleteFileWarning")} okText={t("general.confirm")} cancelText={t("general.cancel")} onOk={() => {
                    this.handleDeleteFile(this.state.confirmModal?.data)
                    flushSync(()=>{this.setState({ confirmModal: null })})
                }}
                    onCancel={() => flushSync(()=>{this.setState({ confirmModal: null })})} />
            </Container>)
        );
    }
}

function mapStateToProps(state) {
    const { authentication, buildings } = state;
    const { user } = authentication;
    const { selected, rights } = buildings;
    return {
        user,
        selected,
        rights
    };
}

const connectedPage = connect(mapStateToProps)(withTranslation()(withStyles(styles)(Page)));
export { connectedPage as StandardOptionsConfigPage };
